import { X } from 'lucide-react';
import clsx from 'clsx';
import type { ReactNode } from 'react';

type CloseButtonProps = {
  onClose: () => void;
  className?: string;
  iconClassName?: string;
  ariaLabel?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'danger' | 'info';
  showIcon?: boolean;
  children?: ReactNode;
};

const CloseButton = ({
  onClose,
  className,
  iconClassName,
  ariaLabel = 'Close',
  type = 'button',
  variant = 'primary',
  showIcon = true,
  children,
}: CloseButtonProps) => {
  const variantClasses = (() => {
    switch (variant) {
      case 'secondary':
        return 'bg-black/70 text-white hover:bg-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white';
      case 'info':
        return 'bg-white text-blue-600 hover:bg-blue-50 ring-1 ring-blue-200';
      case 'danger':
        return 'bg-white hover:bg-red-50 text-red-600 ring-1 ring-red-200';
      case 'primary':
      default:
        return 'text-gray-500 hover:text-black ring-1 ring-gray-300 bg-white';
    }
  })();

  return (
    <button
      type={type}
      aria-label={ariaLabel}
      onClick={onClose}
      className={clsx(
        'absolute right-4 top-4 justify-center rounded-4xl px-2.5 py-2.5',
        variantClasses,
        className,
      )}>
      {showIcon && <X className={clsx('h-5 w-5', iconClassName)} />}
      {children}
    </button>
  );
};

export default CloseButton;
